var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMuxinline = function SvgMuxinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 40,
    fill: "none",
    viewBox: "0 0 98 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5C2B",
    fillRule: "evenodd",
    d: "M3.341 5c1.845 0 3.34 1.474 3.34 3.293v23.414c0 1.818-1.495 3.292-3.34 3.292C1.496 35 0 33.525 0 31.707V8.293C0 6.474 1.496 5 3.341 5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5C2B",
    fillRule: "evenodd",
    d: "M27.841 5c1.845 0 3.34 1.474 3.34 3.293v23.414c0 1.818-1.495 3.292-3.34 3.292-1.845 0-3.341-1.474-3.341-3.292V8.293C24.5 6.474 25.996 5 27.841 5",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4B46",
    fillRule: "evenodd",
    d: "M38.232 5c1.845 0 3.34 1.474 3.34 3.293V20.73c0 4.243 3.49 7.683 7.796 7.683V35c-7.996 0-14.477-6.388-14.477-14.268V8.293C34.89 6.474 36.386 5 38.23 5",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4B46",
    fillRule: "evenodd",
    d: "M60.882 5c-1.846 0-3.341 1.474-3.341 3.293v12.073c0 4.445-3.657 8.048-8.167 8.048V35c8.2 0 14.849-6.551 14.849-14.633V8.293C64.223 6.474 62.727 5 60.882 5",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4174",
    fillRule: "evenodd",
    d: "M68.537 5.964a3.376 3.376 0 0 1 4.725 0L97.02 29.38a3.259 3.259 0 0 1 0 4.656 3.376 3.376 0 0 1-4.725 0L68.537 10.621a3.26 3.26 0 0 1 0-4.657",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4174",
    fillRule: "evenodd",
    d: "M97.018 5.964a3.376 3.376 0 0 0-4.725 0L68.535 29.38a3.259 3.259 0 0 0 0 4.656 3.376 3.376 0 0 0 4.725 0l23.757-23.414a3.259 3.259 0 0 0 0-4.657",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5C2B",
    fillRule: "evenodd",
    d: "M.979 5.964a3.376 3.376 0 0 1 4.724 0l12.25 12.073a3.26 3.26 0 0 1 0 4.657 3.376 3.376 0 0 1-4.724 0L.979 10.62a3.26 3.26 0 0 1 0-4.657",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5C2B",
    fillRule: "evenodd",
    d: "M30.204 5.964a3.26 3.26 0 0 1 0 4.657l-12.25 12.073a3.376 3.376 0 0 1-4.725 0 3.26 3.26 0 0 1 0-4.657l12.25-12.073a3.376 3.376 0 0 1 4.725 0",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5C2B",
    d: "M31.182 31.708c0 1.818-1.496 3.292-3.341 3.292-1.845 0-3.341-1.474-3.341-3.292 0-1.819 1.496-3.293 3.341-3.293 1.845 0 3.34 1.474 3.34 3.293"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4B46",
    d: "M64.217 8.293c0 1.818-1.496 3.292-3.34 3.292-1.846 0-3.342-1.474-3.342-3.292C57.535 6.474 59.031 5 60.876 5c1.845 0 3.341 1.474 3.341 3.293M52.717 31.708c0 1.818-1.496 3.292-3.34 3.292-1.846 0-3.342-1.474-3.342-3.292 0-1.819 1.496-3.293 3.341-3.293 1.845 0 3.341 1.474 3.341 3.293"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4174",
    d: "M97.998 31.708c0 1.818-1.496 3.292-3.34 3.292-1.846 0-3.342-1.474-3.342-3.292 0-1.819 1.496-3.293 3.341-3.293 1.846 0 3.341 1.474 3.341 3.293"
  })));
};
export default SvgMuxinline;